import { groupBy } from 'ramda';

import { EImageType, IOffer, ITypedImage } from '../../types/offer';
import { IGalleryItem } from '../../types/redux/gallery';
import { TMedia } from './types';
import { prepareImagesByType } from './prepareImagesByType';
import { prepareNormalImages } from './prepareNormalImages';

export function prepareFlatSaleGallery(offer: IOffer): IGalleryItem[] {
  const { images, category } = offer;
  const prepareMedia = groupBy((image: ITypedImage) => image.type);
  const media: TMedia = prepareMedia(images || []);

  const layoutImages = prepareImagesByType({ media, type: EImageType.Layout });
  const floorPlanImages = prepareImagesByType({ media, type: EImageType.FloorPlan });
  const normalImages = prepareNormalImages({ media, category });

  const gallery: Array<IGalleryItem | null> = [layoutImages, floorPlanImages, normalImages];

  return gallery.filter<IGalleryItem>((item): item is IGalleryItem => !!item);
}
